import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AfmOther } from '../models/afm-other.model';


@Injectable({
  providedIn: 'root'
})
export class AfmOtherService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {AfmOther} afmOther
   * @return {Promise<any>}
   */
  putAfmOther(airportID: number, afmOther: AfmOther): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/afmOther`;
    try {
      const BODY = this._getAfmOtherJSON(afmOther);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {AfmOther} afmOther
   * @return {any}
   * @private
   */
  _getAfmOtherJSON (afmOther: AfmOther): any {
    return {
      websiteUrl: afmOther.websiteUrl,
      lightWindRwy: afmOther.lightWindRwy,
      gatParking: afmOther.gatParking,
      gatCharted: afmOther.gatCharted,
      gatDescription: afmOther.gatDescription
    };
  }
}
